import styled from 'styled-components';

export const StyledTagsInputWrapper = styled.div`
  width: 100%;

  .ReactTags__tags {
    width: 100%;
    .ReactTags__tagInput {
      width: 100%;

      .ReactTags__tagInputField {
        padding: 10px 5px;
        width: 100%;
        border-radius: 8px;
        border: 1px solid #bbb;
        font-size: 0.95rem;
        height: 100%;
        margin-bottom: 8px;
      }
    }

    .ReactTags__selected {
      display: flex;
      flex-wrap: wrap;

      .ReactTags__tag {
        border: 1px solid #ddd;
        padding: 5px 10px;
        background-color: #eee;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 10px;
        margin-top: 5px;

        .ReactTags__remove {
          border-radius: 50%;
          width: 20px;
          height: 20px;
          border: 1px solid #aaa;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 3px;
          margin-right: 10px;
        }
      }
    }
  }
`;
